import type { ComponentType } from "react";
import { AccountCreateOfferDialog } from "@/components/apprenticeship/enterprise/offer/account-create-dialog";
import { OpportunityEditOfferDialog } from "@/components/apprenticeship/enterprise/offer/opportunity-edit-dialog";

export type CustomActionDialogProps = {
    recordId: string | number;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSuccess?: () => void;
};

/**
 * Actions that own their own dialog (instead of ActionModal).
 * Keep domain UI here so Actions2 stays a thin dispatcher.
 */
export const CUSTOM_ACTION_DIALOGS: Record<string, ComponentType<CustomActionDialogProps>> = {
    create_apprenticeship_offer: AccountCreateOfferDialog,
    edit_apprenticeship_offer: OpportunityEditOfferDialog
};
